module.exports = __webpack_public_path__ + "static/media/refresh.f277f0e3.svg";